import { render, staticRenderFns } from "./privacyAgree.vue?vue&type=template&id=7944bb38&"
import script from "./privacyAgree.vue?vue&type=script&lang=ts&"
export * from "./privacyAgree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ECheckbox: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/checkbox.vue').default})
